// Field help (2026-10-21): what each form field is for, shown by the (i) button next to its label (components/common.tsx
// Field). Keys:
//   "<resource path>.<field>"   a field of a resource form (ResourceForm), e.g. "queues.strategy"
//   "*.<field>"                 the same field in every resource form that has no entry of its own, e.g. "*.status"
//   "<page>.<field>"            a field of a page's own form, e.g. "users.role", "branding.logo"
// The text is English and goes through t(), so en.json / es.json hold it like every other text (English = the key).
// web/e2e/help.e2e.mjs opens every form and fails on a field without help.
import { t } from '@/i18n';
import common from './common';
import callcenter from './callcenter';
import routing from './routing';
import pbx from './pbx';
import pages from './pages';

export const HELP: Record<string, string> = { ...common, ...callcenter, ...routing, ...pbx, ...pages };

// the key a resource form's field uses: its own entry, else the shared one
export function resourceHelpKey(path: string, field: string): string | undefined {
  if (HELP[`${path}.${field}`]) return `${path}.${field}`;
  if (HELP[`*.${field}`]) return `*.${field}`;
  return undefined;
}

// a key of the catalog -> its translated text; any other string is taken as the text itself
export function helpText(key: string | undefined): string | undefined {
  if (!key) return undefined;
  const text = HELP[key];
  if (text) return t(text);
  return key.includes(' ') ? key : undefined;
}
